// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:base-models --tenant projectReplica` to regenerate.
import DatabaseRecord from "velocious/build/src/database/record/index.js"

/**
 * Attributes accepted when creating or updating TaskBoard records.
 * @typedef {object} TaskBoardWriteAttributes
 * @property {string} [id] - Value for the id attribute.
 * @property {string} [boardId] - Value for the boardId attribute.
 * @property {string} [boardColumnId] - Value for the boardColumnId attribute.
 * @property {string} [taskId] - Value for the taskId attribute.
 * @property {number} [rowNumber] - Value for the rowNumber attribute.
 * @property {Date | string} [createdAt] - Value for the createdAt attribute.
 * @property {Date | string} [updatedAt] - Value for the updatedAt attribute.
 * @property {Date | string | null} [lastSyncChangeAt] - Value for the lastSyncChangeAt attribute.
 * @property {string | null} [boardProjectId] - Value for the boardProjectId attribute.
 * @property {string | null} [boardName] - Value for the boardName attribute.
 * @property {string | null} [boardColumnName] - Value for the boardColumnName attribute.
 * @property {import("../models/board.js").default} [board] - Related board record.
 * @property {import("../models/board-column.js").default} [boardColumn] - Related boardColumn record.
 * @property {import("../models/task.js").default} [task] - Related task record.
 */

/** @augments {DatabaseRecord<TaskBoardWriteAttributes>} */
export default class TaskBoardBase extends DatabaseRecord {
  /** @returns {typeof import("../models/task-board.js").default} */
  // @ts-ignore - override narrows return type for better IntelliSense in generated model bases
  getModelClass() { return /** @type {typeof import("../models/task-board.js").default} */ (this.constructor) }

  /** @returns {string} */
  id() { return this.readAttribute("id") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setId(newValue) { return this._setColumnAttribute("id", newValue) }

  /** @returns {boolean} */
  hasId() { return this._hasAttribute(this.id()) }

  /** @returns {string} */
  boardId() { return this.readAttribute("boardId") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setBoardId(newValue) { return this._setColumnAttribute("boardId", newValue) }

  /** @returns {boolean} */
  hasBoardId() { return this._hasAttribute(this.boardId()) }

  /** @returns {string} */
  boardColumnId() { return this.readAttribute("boardColumnId") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setBoardColumnId(newValue) { return this._setColumnAttribute("boardColumnId", newValue) }

  /** @returns {boolean} */
  hasBoardColumnId() { return this._hasAttribute(this.boardColumnId()) }

  /** @returns {string} */
  taskId() { return this.readAttribute("taskId") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setTaskId(newValue) { return this._setColumnAttribute("taskId", newValue) }

  /** @returns {boolean} */
  hasTaskId() { return this._hasAttribute(this.taskId()) }

  /** @returns {number} */
  rowNumber() { return this.readAttribute("rowNumber") }

  /**
   * @param {number} newValue
   * @returns {void}
   */
  setRowNumber(newValue) { return this._setColumnAttribute("rowNumber", newValue) }

  /** @returns {boolean} */
  hasRowNumber() { return this._hasAttribute(this.rowNumber()) }

  /** @returns {Date} */
  createdAt() { return this.readAttribute("createdAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setCreatedAt(newValue) { return this._setColumnAttribute("createdAt", newValue) }

  /** @returns {boolean} */
  hasCreatedAt() { return this._hasAttribute(this.createdAt()) }

  /** @returns {Date} */
  updatedAt() { return this.readAttribute("updatedAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setUpdatedAt(newValue) { return this._setColumnAttribute("updatedAt", newValue) }

  /** @returns {boolean} */
  hasUpdatedAt() { return this._hasAttribute(this.updatedAt()) }

  /** @returns {Date | null} */
  lastSyncChangeAt() { return this.readAttribute("lastSyncChangeAt") }

  /**
   * @param {Date | string | null} newValue
   * @returns {void}
   */
  setLastSyncChangeAt(newValue) { return this._setColumnAttribute("lastSyncChangeAt", newValue) }

  /** @returns {boolean} */
  hasLastSyncChangeAt() { return this._hasAttribute(this.lastSyncChangeAt()) }

  /** @returns {string | null} */
  boardProjectId() { return this.readAttribute("boardProjectId") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setBoardProjectId(newValue) { return this._setColumnAttribute("boardProjectId", newValue) }

  /** @returns {boolean} */
  hasBoardProjectId() { return this._hasAttribute(this.boardProjectId()) }

  /** @returns {string | null} */
  boardName() { return this.readAttribute("boardName") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setBoardName(newValue) { return this._setColumnAttribute("boardName", newValue) }

  /** @returns {boolean} */
  hasBoardName() { return this._hasAttribute(this.boardName()) }

  /** @returns {string | null} */
  boardColumnName() { return this.readAttribute("boardColumnName") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setBoardColumnName(newValue) { return this._setColumnAttribute("boardColumnName", newValue) }

  /** @returns {boolean} */
  hasBoardColumnName() { return this._hasAttribute(this.boardColumnName()) }

  /**
   * @returns {import("../models/board.js").default}
   */
  board() { return /** @type {import("../models/board.js").default} */ (this.getRelationshipByName("board").loaded()) }

  /**
   * @abstract
   * @param {ConstructorParameters<typeof import("../models/board.js").default>[0]} [attributes]
   * @returns {import("../models/board.js").default}
   */
  buildBoard(attributes) { void attributes; throw new Error("Not implemented") }

  /**
   * @abstract
   * @returns {Promise<import("../models/board.js").default | undefined>}
   */
  loadBoard() { throw new Error("Not implemented") }

  /**
   * @returns {Promise<import("../models/board.js").default | undefined>}
   */
  boardOrLoad() { return /** @type {Promise<import("../models/board.js").default | undefined>} */ (this.relationshipOrLoad("board")) }

  /**
   * @abstract
   * @param {import("../models/board.js").default} newModel
   * @returns {void}
   */
  setBoard(newModel) { void newModel; throw new Error("Not implemented") }

  /**
   * @returns {import("../models/board-column.js").default}
   */
  boardColumn() { return /** @type {import("../models/board-column.js").default} */ (this.getRelationshipByName("boardColumn").loaded()) }

  /**
   * @abstract
   * @param {ConstructorParameters<typeof import("../models/board-column.js").default>[0]} [attributes]
   * @returns {import("../models/board-column.js").default}
   */
  buildBoardColumn(attributes) { void attributes; throw new Error("Not implemented") }

  /**
   * @abstract
   * @returns {Promise<import("../models/board-column.js").default | undefined>}
   */
  loadBoardColumn() { throw new Error("Not implemented") }

  /**
   * @returns {Promise<import("../models/board-column.js").default | undefined>}
   */
  boardColumnOrLoad() { return /** @type {Promise<import("../models/board-column.js").default | undefined>} */ (this.relationshipOrLoad("boardColumn")) }

  /**
   * @abstract
   * @param {import("../models/board-column.js").default} newModel
   * @returns {void}
   */
  setBoardColumn(newModel) { void newModel; throw new Error("Not implemented") }

  /**
   * @returns {import("../models/task.js").default}
   */
  task() { return /** @type {import("../models/task.js").default} */ (this.getRelationshipByName("task").loaded()) }

  /**
   * @abstract
   * @param {ConstructorParameters<typeof import("../models/task.js").default>[0]} [attributes]
   * @returns {import("../models/task.js").default}
   */
  buildTask(attributes) { void attributes; throw new Error("Not implemented") }

  /**
   * @abstract
   * @returns {Promise<import("../models/task.js").default | undefined>}
   */
  loadTask() { throw new Error("Not implemented") }

  /**
   * @returns {Promise<import("../models/task.js").default | undefined>}
   */
  taskOrLoad() { return /** @type {Promise<import("../models/task.js").default | undefined>} */ (this.relationshipOrLoad("task")) }

  /**
   * @abstract
   * @param {import("../models/task.js").default} newModel
   * @returns {void}
   */
  setTask(newModel) { void newModel; throw new Error("Not implemented") }
}
